import { CategoryDTO2 } from '../api/api';
import Alert from '../components/alert/Alert';

const useTimeRegAlert = (timeCategoryOptions: CategoryDTO2[], projectNumberHasError: boolean) => {
  const getErrorAlert = () => {
    if (timeCategoryOptions.length === 0)
      return (
        <Alert severity="warning" height="42px">
          Du har ingen arter tilknyttet projektnummeret. Kontakt din leder.
        </Alert>
      );
    if (projectNumberHasError)
      return (
        <Alert severity="error" height="42px">
          Projetnummeret er ikke i korrekt status.
        </Alert>
      );

    return <div />;
  };

  return {
    getErrorAlert
  };
};

export default useTimeRegAlert;
